import * as THREE from 'three';
import { physicsWorld } from './physics.js';

let debugLines = null;
let debugEnabled = false;

export function initDebugRenderer(scene) {
    const material = new THREE.LineBasicMaterial({ 
        color: 0x00ff00,
        linewidth: 1
    });
    const geometry = new THREE.BufferGeometry();
    debugLines = new THREE.LineSegments(geometry, material);
    scene.add(debugLines);
}

export function toggleDebug() {
    debugEnabled = !debugEnabled;
    if (debugLines) {
        debugLines.visible = debugEnabled;
    }
    return debugEnabled;
}

export function updateDebugRenderer() {
    if (!debugEnabled || !debugLines || !physicsWorld) return;

    const buffers = physicsWorld.debugRender();
    const vertices = new Float32Array(buffers.vertices);
    
    debugLines.geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
    debugLines.geometry.computeBoundingSphere();
}

export function isDebugEnabled() {
    return debugEnabled;
}